import api from "@/router/api"

export default {
    getAllTypologies({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesTypologiesVhe.list(payload)
            .then(response => {
                resolve(response.data.data)

                commit('SET_TYPOLOGIES', response.data.data)
            })
            .catch(error => {
                reject({
                    message: 'Ocurrió un problema al obtener las tipologias',
                })
            })
        })
    },
}
